import React, { useState, useContext, useEffect } from 'react';
import {IProps, IState} from './types';
import * as S from './styles';
import C from '@assets/themes/colors';
import { Context } from "routes/private/Editor/Context";
import AddTextIcon from '@assets/icons/addTextIcon';
import ToolTip from '@components/Tooltip';

const TextTool:React.FC<IProps> = (props) => {
  let context = useContext(Context);
  
  const handleOpenNewText = () => {  
    const picker = (context.editorStatus.currentPicker==="AddNewText")?undefined:"AddNewText";
    context.onShowPicker(picker);
  }
  
  return (
    <S.Root>
      <S.IconContainer
        onClick={handleOpenNewText}
      >
        <ToolTip
          tip="Add Text"
          boxStyle={{
            top: `0px`,
            left: `30px`,
            right: `auto`,
            width: `140px`,
            justifyContent: `start`
          }} 
        >
          <AddTextIcon
            style={{fillColor: (context.editorStatus.currentPicker==="AddNewText") ? C.WHITE : undefined}}
          />
        </ToolTip>
      </S.IconContainer>
    </S.Root>
  );
}

export default TextTool;